import { createSlice } from '@reduxjs/toolkit';

import { fetchProfile, setProfileDefaultHospital } from './profile-api';
import type { User } from '@/types/auth';
import { logout } from '../auth/logout';

export interface ProfileState {
    profile: User | null;
    loading: boolean;
    error: string | null;
}

const initialState: ProfileState = {
    profile: null,
    loading: false,
    error: null
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        clearProfile: (state) => {
            state.profile = null;
            state.error = null;
            state.loading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profile = action.payload;
                state.error = null;
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.loading = false;
                const payloadError = typeof action.payload === 'string' ? action.payload : undefined;
                state.error = payloadError ?? action.error.message ?? 'Failed to fetch profile';
            })
            .addCase(setProfileDefaultHospital.fulfilled, (state, { payload }) => {
                if (!state.profile) return;
                state.profile.hospitals = (state.profile.hospitals || []).map((hospital) => ({
                    ...hospital,
                    isDefault: hospital.id === payload.hospitalId
                }));
            })
            .addCase(logout, () => initialState);
    }
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
